var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-page"},[_c('autoplay-video',[_c('source',{attrs:{"src":_vm.videoMp4,"type":"video/mp4"}}),_c('source',{attrs:{"src":_vm.videoWebm,"type":"video/webm"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }